module.exports = function() {
  return new Worker(__webpack_public_path__ + "e8be281791b297cd80be.worker.js");
};